import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mfp-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() breadcrumbs: string[] = [];
  @Output() breadcrumbClick = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  breadcrumbClicked(breadcrumb: string) {
    if (breadcrumb !== this.breadcrumbs[this.breadcrumbs.length - 1]) {
      this.breadcrumbClick.emit(breadcrumb);
    }
  }
}
